module.exports = __webpack_public_path__ + "static/media/JustFleckless–710MoonGrey.605b574f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/JustFleckless–710MoonGrey.jpg
// module id = 23
// module chunks = 0